import { TypographyVariant } from '@ben/orion/utils/theme';
import Icon, { IconName } from '@ben/orion/icon';
import Typography from '@ben/orion/typography';
import type { LifeEventRestrictionComponent } from '@ben/shared/types/columbia';
import styled, { css } from 'styled-components';
import RestrictionComponent from './restriction-component';

interface RestrictionStepProps {
  index: number;
  stepId: number;
  lifeEventIndex: number;
  isExpanded: boolean;
  onToggle: (index: number) => void;
  components: LifeEventRestrictionComponent[];
}

const RestrictionStep = ({
  index,
  stepId,
  lifeEventIndex,
  isExpanded,
  onToggle,
  components,
}: RestrictionStepProps) => {
  return (
    <Wrapper id={`step-${index}`}>
      <StepHeaderWrapper onClick={() => onToggle(index)}>
        <StepHeaderIconTextWrapper>
          <Chevron $isOpen={isExpanded} name={IconName.ArrowsDown} />
          <Typography variant={TypographyVariant.bodyLg3}>
            Step #{index + 1}
          </Typography>
        </StepHeaderIconTextWrapper>
      </StepHeaderWrapper>
      <VisibilityContainer $isOpen={isExpanded} aria-hidden={!isExpanded}>
        {components.map((component) => (
          <RestrictionComponent
            key={component.componentId}
            component={component}
            lifeEventIndex={lifeEventIndex}
            stepId={stepId}
          />
        ))}
      </VisibilityContainer>
    </Wrapper>
  );
};

export default RestrictionStep;

const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.spacing(3)};
    align-self: stretch;
  `};
`;

const StepHeaderWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `};
`;

const StepHeaderIconTextWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(1)};
    align-items: center;
  `};
`;

const Chevron = styled(Icon)<{ $isOpen: boolean }>`
  transform: rotate(${({ $isOpen }) => ($isOpen ? '0deg' : '-90deg')});
  cursor: pointer;
`;

const VisibilityContainer = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'contents' : 'none')};
`;
